export const jsonToString = (obj) => JSON.stringify(obj || {})
